import { AiAssistantPanel } from '@/components/ai/AiAssistantPanel';

export function AiAssistantPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">KI-Assistent</h1>
        <p className="text-muted-foreground">
          Chat mit dem Assistenten: Nachfragen stellen, Ergebnisse als Tabelle oder Grafik anzeigen.
        </p>
      </div>
      <AiAssistantPanel />
    </div>
  );
}
